<template>
    <ai-grid-virtual-base
        ref="gridInstance"
        :meta="meta"
        selectionMode='single'
        :customContextMenu="customContextMenu"
        :to-remove-toolbar-items-names="toRemoveToolbarItemsNames"
        :current-value="currentValue"
        :auto-load-data="meta.autoLoadData || false"
        @toolbar-button-click="toolbarButtonClick"
    />
</template>
<script setup>
import AiGridVirtualBase from "@/components/ai-grid-virtual/ai-grid-virtual-base.vue";
import {ref} from "vue";

const props = defineProps({
    meta: {
        type: Object,
        default: () => ({columns: []}),
    },
    rowClickCallBack: {
        type: Function,
        default: () => {},
    },
    currentValue:{
        type: String,
    },
});
const emit = defineEmits(['dictionarySelectionChanged']);
const customContextMenu =[{name: 'gotoCard', visible: false}];
const toRemoveToolbarItemsNames =['copy','edit','add','delete','save'];
const gridInstance = ref();

const toolbarButtonClick = event =>{
    if(event.item.component.name === 'choice'){
        const rowData = gridInstance.value.gridInstance.option('dataSource').items()
            .find(row => row[props.meta.keyExpr] === gridInstance.value.gridInstance.option('focusedRowKey'));
        if (props.rowClickCallBack) {
            props.rowClickCallBack({ row: rowData, keyExpr: props.meta.keyExpr });
        }
        emit('dictionarySelectionChanged', rowData);
    }
}
defineExpose({
    gridInstance,
});
</script>